import {
  GetReversalPayrollsParams,
  GetReversalPayrollsResponse,
  GetTimesheetByIdParams,
  GetTimesheetByIdResponse,
  PerformReversalPayrollsParams,
  PerformReversalPayrollsResponse,
  CancelTimesheetParams,
  CancelTimesheetResponse,
  ValidateDraftPayrollParams,
  ValidateDraftPayrollResponse,
  GenerateDraftPayrollParams,
  GenerateDraftPayrollResponse,
  GenerateInvoiceParams,
  GenerateInvoiceResponse,
  CreateTimesheetParams,
  CreateTimesheetResponse,
  UpdateTimesheetParams,
  UpdateTimesheetResponse,
  ChangeTaxPeriodParams,
  ChangeTaxPeriodResponse,
  BulkChangeTaxPeriodParams,
  BulkChangeTaxPeriodResponse,
  GetTimesheetImportsParams,
  GetTimesheetImportsResponse,
  GetTimesheetGroupingParams,
  GetTimesheetGroupingResponse,
  ApproveTimesheetParams,
  ApproveTimesheetResponse,
  SaveRunPayrollParams,
  SaveRunPayrollResponse,
  CancelSalaryParams,
  CancelSalaryResponse,
} from '@nxsys/types/api';
import { endPoints } from '../endpoints';
import axios from '../axios';

export const getReversalPayrollsApi = async (
  params: GetReversalPayrollsParams,
): Promise<GetReversalPayrollsResponse> => {
  const response = await axios.post(
    endPoints.report.payroll.reversalPayroll,
    params,
  );
  return response.data;
};

export const performReversalPayrollsApi = async (
  params: PerformReversalPayrollsParams,
): Promise<PerformReversalPayrollsResponse> => {
  const response = await axios.put(
    endPoints.report.payroll.reversalPayroll,
    params,
  );
  return response.data;
};

export const getTimesheetByIdApi = async (
  params: GetTimesheetByIdParams,
): Promise<GetTimesheetByIdResponse> => {
  const response = await axios.get(`${endPoints.timesheet.main}/${params.id}`);
  return response.data;
};

export const cancelTimesheetApi = async (
  params: CancelTimesheetParams,
): Promise<CancelTimesheetResponse> => {
  const response = await axios.put(
    `${endPoints.timesheet.main}/cancel/time-sheet`,
    params,
  );
  return response.data;
};

export const validateDraftPayrollApi = async (
  params: ValidateDraftPayrollParams,
  isBureau: boolean,
): Promise<ValidateDraftPayrollResponse> => {
  const url = isBureau
    ? endPoints.report.payroll.validateDraftBureau
    : endPoints.report.payroll.validateDraft;
  const response = await axios.post(url, params);
  return response.data;
};

export const generateDraftPayrollApi = async (
  params: GenerateDraftPayrollParams,
  isIreland: boolean,
): Promise<GenerateDraftPayrollResponse> => {
  const response = await axios.post(
    `${endPoints.report.payroll.draft}${isIreland ? '/?isIreland=true' : ''}`,
    params,
  );
  return response.data;
};

export const generateInvoiceApi = async (
  params: GenerateInvoiceParams,
): Promise<GenerateInvoiceResponse> => {
  const response = await axios.put(endPoints.timesheet.invoice, params);
  return response.data;
};

export const createTimesheetApi = async (
  params: CreateTimesheetParams,
): Promise<CreateTimesheetResponse> => {
  const response = await axios.post(endPoints.timesheet.main, params);
  return response.data;
};

export const updateTimesheetApi = async (
  params: UpdateTimesheetParams,
): Promise<UpdateTimesheetResponse> => {
  const response = await axios.put(
    `${endPoints.timesheet.main}/${params.id}`,
    params.payload,
  );
  return response.data;
};

export const changeTaxPeriodApi = async (
  params: ChangeTaxPeriodParams,
): Promise<ChangeTaxPeriodResponse> => {
  const { id, taxPeriod, reason, skipReapproval } = params;
  const response = await axios.put(endPoints.timesheet.taxPeriod(id), {
    taxPeriod,
    reason,
    skipReapproval,
  });
  return response.data;
};

export const bulkChangeTaxPeriodApi = async (
  params: BulkChangeTaxPeriodParams,
): Promise<BulkChangeTaxPeriodResponse> => {
  const response = await axios.put(endPoints.timesheet.bulkTaxPeriod, params);
  return response.data;
};

export const getTimesheetImportsApi = async (
  params: GetTimesheetImportsParams,
): Promise<GetTimesheetImportsResponse> => {
  const response = await axios.get(endPoints.timesheet.imports, { params });
  return response.data;
};

export const getTimesheetGroupingApi = async (
  params: GetTimesheetGroupingParams,
): Promise<GetTimesheetGroupingResponse> => {
  const response = await axios.get(endPoints.timesheet.groupingTimesheets, {
    params,
  });
  return response.data;
};

export const approveTimesheetApi = async (
  params: ApproveTimesheetParams,
): Promise<ApproveTimesheetResponse> => {
  const response = await axios.put(endPoints.timesheet.approval, params.ids);
  return response.data;
};

export const getBureauTimesheetGroupingApi = async (
  params: GetTimesheetGroupingParams,
): Promise<GetTimesheetGroupingResponse> => {
  const response = await axios.get(endPoints.timesheet.groupingList, {
    params,
  });
  return response.data;
};

export const saveRunPayrollApi = async (
  params: SaveRunPayrollParams,
): Promise<SaveRunPayrollResponse> => {
  const response = await axios.post(endPoints.timesheet.saveRunPayroll, params);
  return response.data;
};

export const cancelSalaryApi = async (
  params: CancelSalaryParams,
): Promise<CancelSalaryResponse> => {
  const response = await axios.delete(endPoints.timesheet.saveRunPayroll, {
    data: params,
  });
  return response.data;
};
